export type ShortcutAction="quick"|"search"|"clear"|"today";
/** Explicit modifiers avoid interfering with text input and browser search. */
export function shortcutAction(event:{altKey:boolean;ctrlKey:boolean;metaKey:boolean;shiftKey:boolean;key:string;repeat?:boolean}):ShortcutAction|null{
 if(!event.altKey||event.ctrlKey||event.metaKey||event.shiftKey||event.repeat)return null;
 return ({n:"quick",s:"search",x:"clear",h:"today"} as Record<string,ShortcutAction>)[event.key.toLowerCase()]??null;
}
